module.exports = __webpack_public_path__ + "static/media/LUP_zast_L0.c0789aa7.svg";